export enum DtwinImportMode {
  REPORT = "report",
  EXECUTION = "execution",
}
